import { render, staticRenderFns } from "./ReceivingItemCard.vue?vue&type=template&id=e8716356&"
import script from "./ReceivingItemCard.vue?vue&type=script&lang=js&"
export * from "./ReceivingItemCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports